module.exports = __webpack_public_path__ + "img/upload-image.2dfd4d03.png";